var _desc, _path, _circle, _circle2, _circle3, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChickenBreast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    strokeWidth: 3,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chicken Breast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A line styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M12.983 44.548l-4.234 4.237A4.131 4.131 0 0 0 3.212 54.9c2.143 2.143 2.934 1.471 3.658 2.2 1 1 .426 1.887 2.2 3.66a4.142 4.142 0 0 0 5.857-5.86 4.123 4.123 0 0 0-.334-.25l4.228-4.228",
    "data-name": "layer2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    r: 1,
    cy: 9.97,
    cx: 43.999,
    "data-name": "layer2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    r: 1,
    cy: 11.974,
    cx: 35.999,
    "data-name": "layer2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    r: 1,
    cy: 17.972,
    cx: 45.999,
    "data-name": "layer2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: "M55.85 8.175a21 21 0 0 0-29.7 0A21.827 21.827 0 0 0 24.618 9.9c-.1.127-.193.268-.291.4-.332.434-.658.869-.951 1.32-6.2 9.3-6.746 23.059-9.244 25.555l-.709.709a5 5 0 0 0 0 7.072l5.658 5.656a5 5 0 0 0 7.07 0l.709-.709c2.676-2.676 17.549-2.391 27.35-10.547a21.513 21.513 0 0 0 1.641-1.475 21 21 0 0 0-.001-29.706z",
    "data-name": "layer1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChickenBreast);
export default __webpack_public_path__ + "static/media/chicken-breast.72b045bc.svg";
export { ForwardRef as ReactComponent };